import { useDictionary } from '@/core/providers/dictionary-provider';

export function LegalLinks() {
  const dict = useDictionary();
  const legalDict = dict.auth.legal;
  const legalLinksText = legalDict.text;
  const termsIndex = legalLinksText.indexOf('{termsOfService}');
  const privacyIndex = legalLinksText.indexOf('{privacyPolicy}');

  return (
    <p className="text-xs text-center text-muted-foreground">
      {termsIndex < privacyIndex ? (
        <>
          {legalLinksText.substring(0, termsIndex)}
          <a
            href="https://www.up2promo.com/policies/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-foreground"
          >
            {legalDict.termsOfService}
          </a>
          {legalLinksText.substring(
            termsIndex + '{termsOfService}'.length,
            privacyIndex,
          )}
          <a
            href="https://www.up2promo.com/policies/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-foreground"
          >
            {legalDict.privacyPolicy}
          </a>
          {legalLinksText.substring(privacyIndex + '{privacyPolicy}'.length)}
        </>
      ) : (
        <>
          {legalLinksText.substring(0, privacyIndex)}
          <a
            href="https://www.up2promo.com/policies/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-foreground"
          >
            {legalDict.privacyPolicy}
          </a>
          {legalLinksText.substring(
            privacyIndex + '{privacyPolicy}'.length,
            termsIndex,
          )}
          <a
            href="https://www.up2promo.com/policies/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-foreground"
          >
            {legalDict.termsOfService}
          </a>
          {legalLinksText.substring(termsIndex + '{termsOfService}'.length)}
        </>
      )}
    </p>
  );
}
